/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import luiIconLoader from './lui-icon-loader'

class LuiIconManifestLoader {
  constructor(manifestPath) {
    this.manifestPath = manifestPath
  }

  getIcon(iconName) {
    const svgPromise = this._loadSvg(iconName)
    return svgPromise
  }

  _loadSvg(iconName) {
    return new Promise((resolve, reject) => {
      this._manifest
        .then((manifestData) => {
          this._manifestJson = JSON.parse(manifestData)
          const keyName = iconName + '.svg'
          if (this._manifestJson.hasOwnProperty(keyName)) {
            resolve(luiIconLoader.loadSvg(this._manifestJson[keyName]))
          } else {
            reject(new Error('No key in ' + this.manifestPath))
          }
        })
    })
  }

  _loadManifest(manifestPath) {
    return new Promise((resolve, reject) => {
      const xhr = new window.XMLHttpRequest()
      xhr.open('GET', `${manifestPath}`, true)
      xhr.send()
      xhr.addEventListener('load', (e) => {
        if (e.target.status >= 200 && e.target.status < 300) {
          resolve(xhr.responseText)
        } else {
          reject(e.target.status)
        }
      })
    })
  }

  set manifestPath(value) {
    this._manifestPath = value
    this._manifest = this._loadManifest(this.manifestPath)
  }

  get manifestPath() {
    return this._manifestPath
  }
}

export default LuiIconManifestLoader
window.lui.LuiIconManifestLoader = LuiIconManifestLoader



//////////////////
// WEBPACK FOOTER
// ./packages/lui-icon/loader/lui-icon-manifest-loader.js
// module id = 219
// module chunks = 0 1 12